"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Image from "next/image";
import { usePathname, useSearchParams } from "next/navigation";
import { useViewContext } from "./ViewContext";
import type { NavItem as NavItemData } from "./navTypes";
import { motion } from "framer-motion";
import { useAuth } from "../auth/Auth";
import { useTitle } from "@/contexts/TitleContext";
import { useUnreadNotifications } from "@/hooks/useUnreadNotifications";
import { useUnreadIndicator } from "@/hooks/useUnreadIndicator";
import { useNotificationsContext } from "../notifications/NotificationsContext";
import { isNavItemActive } from "./isNavItemActive";
import { useWaveData } from "@/hooks/useWaveData";
import { useWave } from "@/hooks/useWave";
interface Props {
  readonly item: NavItemData;
}
const NavItem = t0 => {
  const $ = _c(59);
  const {
    item
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    activeView,
    handleNavClick
  } = useViewContext();
  const {
    name
  } = item;
  const {
    icon
  } = item;
  const isLogoItem = name === "Home";
  let t1;
  if ($[0] !== searchParams) {
    t1 = typeof searchParams?.get("wave") === "string" ? searchParams?.get("wave") : null;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const waveIdFromQuery = t1;
  let t2;
  if ($[2] !== waveIdFromQuery) {
    t2 = {
      waveId: waveIdFromQuery,
      onWaveNotFound: _temp
    };
    $[2] = waveIdFromQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: waveData
  } = useWaveData(t2);
  const {
    isDm: isCurrentWaveDmValue
  } = useWave(waveData);
  const {
    connectedProfile
  } = useAuth();
  const {
    setTitle
  } = useTitle();
  const {
    notifications,
    haveUnreadNotifications
  } = useUnreadNotifications(item.name === "Notifications" ? connectedProfile?.handle ?? null : null);
  const t3 = item.name === "Messages" ? connectedProfile?.handle ?? null : null;
  let t4;
  if ($[4] !== t3) {
    t4 = {
      type: "messages",
      handle: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    hasUnread: hasUnreadMessages
  } = useUnreadIndicator(t4);
  const {
    removeAllDeliveredNotifications
  } = useNotificationsContext();
  let t5;
  if ($[6] !== haveUnreadNotifications || $[7] !== item.name || $[8] !== notifications?.unread_count || $[9] !== removeAllDeliveredNotifications || $[10] !== setTitle) {
    t5 = () => {
      if (item.name !== "Notifications") {
        return;
      }
      setTitle(haveUnreadNotifications ? `(${notifications?.unread_count}) Notifications | 6529.io` : "6529.io");
      if (!haveUnreadNotifications) {
        removeAllDeliveredNotifications();
      }
    };
    $[6] = haveUnreadNotifications;
    $[7] = item.name;
    $[8] = notifications?.unread_count;
    $[9] = removeAllDeliveredNotifications;
    $[10] = setTitle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = notifications?.unread_count;
  let t7;
  if ($[12] !== haveUnreadNotifications || $[13] !== t6) {
    t7 = [haveUnreadNotifications, t6];
    $[12] = haveUnreadNotifications;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  useEffect(t5, t7);
  if (item.disabled) {
    let t8;
    if ($[15] !== icon || $[16] !== item.iconComponent || $[17] !== item.iconSizeClass || $[18] !== name) {
      t8 = <div className="tw-flex tw-items-center tw-justify-center">{item.iconComponent ? <item.iconComponent className={`${item.iconSizeClass ?? "tw-size-7"} tw-text-iron-500`} /> : <Image src={icon} alt={name} width={24} height={24} unoptimized={true} className={item.iconSizeClass ?? "tw-size-7"} />}</div>;
      $[15] = icon;
      $[16] = item.iconComponent;
      $[17] = item.iconSizeClass;
      $[18] = name;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    let t9;
    if ($[20] !== name || $[21] !== t8) {
      t9 = <button type="button" aria-label={name} aria-disabled="true" disabled={true} className="tw-relative tw-bg-transparent tw-border-0 tw-flex tw-flex-col tw-items-center tw-justify-center focus:tw-outline-none tw-transition-colors tw-w-full tw-h-16 tw-opacity-40 tw-pointer-events-none tw-min-w-0">{t8}</button>;
      $[20] = name;
      $[21] = t8;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    return t9;
  }
  const iconSizeClass = item.iconSizeClass ?? "tw-size-7";
  const t8 = pathname ?? "";
  let t9;
  if ($[23] !== searchParams) {
    t9 = searchParams ?? new URLSearchParams();
    $[23] = searchParams;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== activeView || $[26] !== isCurrentWaveDmValue || $[27] !== item || $[28] !== t8 || $[29] !== t9) {
    t10 = isNavItemActive(item, t8, t9, activeView, isCurrentWaveDmValue);
    $[25] = activeView;
    $[26] = isCurrentWaveDmValue;
    $[27] = item;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  const isActive = t10;
  const t11 = isActive ? "page" : undefined;
  let t12;
  if ($[31] !== handleNavClick || $[32] !== item) {
    t12 = () => handleNavClick(item);
    $[31] = handleNavClick;
    $[32] = item;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== isActive || $[35] !== isLogoItem) {
    t13 = isActive && <motion.div layoutId="nav-indicator" className={`tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-0.5 tw-bg-white tw-rounded-full ${isLogoItem ? "tw-top-1" : ""}`} />;
    $[34] = isActive;
    $[35] = isLogoItem;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== icon || $[38] !== iconSizeClass || $[39] !== isActive || $[40] !== item.iconComponent || $[41] !== name) {
    t14 = item.iconComponent ? <item.iconComponent className={`${iconSizeClass} ${isActive ? "tw-text-white" : "tw-text-iron-500"}`} /> : <Image src={icon} alt={name} width={24} height={24} unoptimized={true} className={iconSizeClass} />;
    $[37] = icon;
    $[38] = iconSizeClass;
    $[39] = isActive;
    $[40] = item.iconComponent;
    $[41] = name;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== haveUnreadNotifications || $[44] !== item.name) {
    t15 = item.name === "Notifications" && haveUnreadNotifications && <div className="tw-absolute -tw-right-1 -tw-top-1 tw-rounded-full tw-bg-red tw-h-2.5 tw-w-2.5" />;
    $[43] = haveUnreadNotifications;
    $[44] = item.name;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== hasUnreadMessages || $[47] !== item.name) {
    t16 = item.name === "Messages" && hasUnreadMessages && <div className="tw-absolute -tw-right-1 -tw-top-1 tw-rounded-full tw-bg-red tw-h-2.5 tw-w-2.5" />;
    $[46] = hasUnreadMessages;
    $[47] = item.name;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== t14 || $[50] !== t15 || $[51] !== t16) {
    t17 = <div className="tw-relative tw-flex tw-items-center tw-justify-center">{t14}{t15}{t16}</div>;
    $[49] = t14;
    $[50] = t15;
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== name || $[54] !== t11 || $[55] !== t12 || $[56] !== t13 || $[57] !== t17) {
    t18 = <button type="button" aria-label={name} aria-current={t11} onClick={t12} className={"tw-relative tw-bg-transparent tw-border-0 tw-flex tw-flex-col tw-items-center tw-justify-center focus:tw-outline-none tw-transition-colors \n      tw-w-full tw-h-16 tw-min-w-0"}>{t13}{t17}</button>;
    $[53] = name;
    $[54] = t11;
    $[55] = t12;
    $[56] = t13;
    $[57] = t17;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  return t18;
};
export default NavItem;
function _temp() {}